import React, { useState, useEffect} from 'react'
//import { createThread } from '../../util/feedback_util'
import {fetchAllWorkInstructions} from '../../../util/wi_util'
import {fetchAllUsers} from '../../../util/user_util'
import { createThread } from '../../../util/feedback_util'

 const CreateThread = ({currentUser, currentUserId, currentUserRole, closeModal, loadData}) =>{
    const [threadName, setThreadName] = useState('');
    const [workInstructions, setWorkInstructions] = useState([]);
    const [users, setUsers] = useState([]); 
    const [selectedWorkInstruction, setSelectedWorkInstruction] = useState('');
    const [selectedUsers, setSelectedUsers] = useState([]);


    useEffect(() => {
        const fetchWorkInstructions = async () => {
            try {

                const [workInstructionsData, usersData] = await Promise.all([
                    fetchAllWorkInstructions(),
                    fetchAllUsers()
                ]);
                setWorkInstructions(workInstructionsData);
                setUsers(usersData);

            } catch (error) {
                console.error('Error fetching work instructions:', error);
            }
        };
        fetchWorkInstructions();
    }, []); 
    
    const createThreadFunc = () => {
        const selectedWI = workInstructions.find(wi => wi._id === selectedWorkInstruction);
        
        // Find all selected users to get their usernames
        const selectedUserObjects = users
            .filter(user => selectedUsers.includes(user._id))
            .map(user => ({
                _id: user._id,
                username: user.username
            }));

        selectedUserObjects.push({_id:currentUserId,username:currentUser.username})

        const threadData = {
            threadName: threadName.trim(),
            author: currentUserId,
            workInstruction: {
                _id: selectedWorkInstruction,
                title: selectedWI ? selectedWI.title : ''
            },
            users: selectedUserObjects,
            
        };


        createThread(threadData).then((res) => {
            console.log(res)
            closeModal();
            console.log('Thread Data:', threadData);
            // You can now send this da
        })
    }

    return (
        <div style={{width: '450px',height: '450px',}}>
            {/* <h2>New Thread Parent</h2> */}
            <div className="message-input_RL20" style={{ marginBottom: '20px' }}>
                {/* <label htmlFor="threadName" style={{ display: 'block', marginBottom: '8px' }}>Thread Name:</label> */}
                <input 
                    type="text" 
                    id="threadName"
                    className="input-box"
                    value={threadName} 
                    placeholder="Enter Thread Name"
                    onChange={(e) => setThreadName(e.target.value)} 
                    style={{ width: '96%', padding: '8px' }}
                />
            </div>
        
            <div className="message-input_RL20" style={{ marginBottom: '20px' }}>
                <label htmlFor="workInstructions" style={{ display: 'block', marginBottom: '8px' }}>Select Work Instructions:</label>
                <select 
                    id="workInstructions"
                    style={{ width: '100%', padding: '8px' ,borderRadius:"5px" }}
                    onChange={(e) => setSelectedWorkInstruction(e.target.value)}
                    value={selectedWorkInstruction}
                >
                    <option value="">Select a work instruction...</option>
                    {workInstructions.map((instruction) => (
                        <option key={instruction._id} value={instruction._id}>
                            {instruction.title}
                        </option>
                    ))}
                </select>
            </div>

            <div className="message-input_RL20" style={{ marginBottom: '20px' }}>
        
                   <label style={{ display: 'block', marginBottom: '8px' }}>Select Users:</label>
            <div style={{ 
                border: '1px solid #ccc', 
                borderRadius: '5px', 
                maxHeight: '200px', 
                overflowY: 'auto',
                padding: '8px'
            }}>
                {users.map((user) => (
                    <div 
                        key={user._id} 
                        style={{ 
                            display: 'flex', 
                            alignItems: 'center',
                            padding: '4px 0'
                        }}
                    >
                        <input
                            type="checkbox"
                            id={`user-${user._id}`}
                            value={user._id}
                            checked={selectedUsers.includes(user._id) || user._id === currentUserId}
                            disabled={user._id === currentUserId}
                            onChange={(e) => {
                                if (e.target.checked) {
                                    setSelectedUsers([...selectedUsers, user._id]);
                                    console.log(selectedUsers)
                                } else {
                                    setSelectedUsers(selectedUsers.filter(id => id !== user._id));
                                }
                            }}
                            style={{ marginRight: '8px' }}
                        />
                        <label 
                            htmlFor={`user-${user._id}`}
                            style={{ color: user._id === currentUserId ? '#666' : 'inherit' }}
                        >
                            {user.username} {user._id === currentUserId && '(You)'}
                        </label>
                    </div>
                ))}
            </div>
            </div>


            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-evenly',borderRadius:"5px" }}>
                <button 
                    onClick={()=>createThreadFunc()}
                    disabled={!threadName.trim() || !selectedWorkInstruction || selectedUsers.length < 1}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: !threadName.trim() || !selectedWorkInstruction || selectedUsers.length < 1 
                            ? '#cccccc' 
                            : '#007bff',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: !threadName.trim() || !selectedWorkInstruction || selectedUsers.length < 1 
                            ? 'not-allowed' 
                            : 'pointer',
                        fontSize: '16px'
                    }}
                    onMouseOver={(e) => {
                        if (threadName.trim() && selectedWorkInstruction && selectedUsers.length >= 1) {
                            e.target.style.backgroundColor = '#0056b3'
                        }
                    }}
                    onMouseOut={(e) => {
                        if (threadName.trim() && selectedWorkInstruction && selectedUsers.length >= 1) {
                            e.target.style.backgroundColor = '#007bff'
                        }
                    }}
                >
                    Create Thread
                </button>
            </div>



        </div>

    );
} 

export default CreateThread;